import React from "react";
import {useTranslation} from "react-i18next";
import {ChangeDateFormat} from "../../../Common/Helpers/ChangeDateFormat";
import {CollapsibleSection} from "../../../Common/Components/Detail/CollapsibleSection";
import {CheckMobile} from "../../../AppSystem/Helpers/CheckMobile";

/*
Ärendelogg: the history of the attest (submitted, attested or denied, paid out),
built by the backend in AttestHelper.MapAttest.
*/
export function AttestLogSection({log}) {
    const {t} = useTranslation();
    const isMobile = CheckMobile(998);

    if (!Array.isArray(log) || log.length === 0) {
        return null;
    }

    // The comment column carries the payment reference on the payout row and the
    // reason on the denied one, so only the payout prefixes its value.
    const hasComment = log.some(item => item.comment);
    const commentText = (item) => {
        if (!item.comment) return '';
        return item.type === 'Utbetalt' ? `${t('attest.paymentId')} ${item.comment}` : item.comment;
    };

    const typeLabel = (type) => {
        if (type === 'Inlämnat') return t('attest.logSubmitted');
        if (type === 'Attesterat') return t('attest.logAttested');
        if (type === 'Nekat') return t('attest.logDenied');
        if (type === 'Utbetalt') return t('attest.logPaid');
        return type;
    };

    /*
    Mobile: cards instead of the table. The payout row adds a fourth column, which
    on a phone would only be reachable by scrolling sideways.
    */
    if (isMobile) {
        return (
            <CollapsibleSection title={t('attest.caseLog')}>
                <div className="reimbursement-cards-list att-log-cards">
                    {log.map((item, index) => (
                        <div key={`logCard${index}`} className="reimbursement-card-item">
                            <div className="reimbursement-card-content-row">
                                <div className="reimbursement-card-left">
                                    <div className="reimbursement-card-purpose">{typeLabel(item.type)}</div>
                                    {item.userName ?
                                        <div className="reimbursement-card-org">{item.userName}</div>
                                    : ''}
                                    {item.comment ?
                                        <div className="reimbursement-card-org">{commentText(item)}</div>
                                    : ''}
                                </div>
                                <div className="reimbursement-card-right">
                                    <div className="reimbursement-card-date">
                                        {item.date ? ChangeDateFormat('dateTime', item.date) : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </CollapsibleSection>
        );
    }

    return (
        <CollapsibleSection title={t('attest.caseLog')}>
            <div className="sl-wrap">
                <div className="sl-card-shell">
                    <div className="att-related-scroll">
                        <table className="sl-table sl-table-layout">
                            <thead>
                                <tr className="sl-table-head-row">
                                    <th className="sl-th-base sl-th-no-sort att-related-nowrap">
                                        <span className="sl-th-label-static">{t('attest.logEvent')}</span>
                                    </th>
                                    <th className="sl-th-base sl-th-no-sort att-related-nowrap">
                                        <span className="sl-th-label-static">{t('modelLabel.date')}</span>
                                    </th>
                                    <th className="sl-th-base sl-th-no-sort">
                                        <span className="sl-th-label-static">{t('modelLabel.user')}</span>
                                    </th>
                                    {hasComment ?
                                        <th className="sl-th-base sl-th-no-sort">
                                            <span className="sl-th-label-static">{t('modelLabel.comment')}</span>
                                        </th>
                                    : ''}
                                </tr>
                            </thead>
                            <tbody>
                                {log.map((item, index) => (
                                    <tr
                                        key={`log${index}`}
                                        className={`sl-row ${index < log.length - 1 ? 'sl-row-divider' : ''}`}
                                    >
                                        <td className="sl-td-base att-related-nowrap">{typeLabel(item.type)}</td>
                                        <td className="sl-td-base att-related-nowrap">
                                            {item.date ? ChangeDateFormat('dateTime', item.date) : ''}
                                        </td>
                                        <td className="sl-td-base">{item.userName || ''}</td>
                                        {hasComment ?
                                            <td className="sl-td-base">{commentText(item)}</td>
                                        : ''}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </CollapsibleSection>
    );
}
